import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailService } from '../../services/email.service';
import { Environment } from '../../environment';
import { first } from 'rxjs/operators';

@Component({
  selector: 'finders-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss']
})
export class EmailDialogComponent implements OnInit {
  public emailForm: FormGroup;
  public sending = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EmailDialogComponent>,
    private emailService: EmailService,
    private env: Environment,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngOnInit() {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  public submitEmailForm() {
    const _form = this.emailForm.value;

    if (this.emailForm.valid) {
      this.emailService
        .sendEmail({
          email: _form.email,
          product: this.env.product,
          pLocation: this.data.locations
        })
        .pipe(first())
        .subscribe(() => {
          this.sending = true;
          this.dialogRef.close(_form.email);
        });
    }
  }
}
